import { types } from 'mobx-state-tree';

import { Address } from '../definitions/Common';
import SupportedProvinces from '../definitions/SupportedProvinces';


const AddressModel = Address
    .named('Address')
    .props({
        // To be deprecated in V9, this is currently
        //  used in the FE to create intl messages
        //  so it shouldn't have to be stored in the document
        streetCombined: types.maybeNull(types.string),

        // Limit provinces to our supported ones
        province: types.maybe(types.enumeration(SupportedProvinces)),
    });

export default AddressModel;